<nav id="navPanel" class="bg-light border-bottom box-shadow fixed-top navbar-expand-lg">
	<app-header></app-header>
</nav>
<div class="main-panel pt-0 pb-4" style="background-color: #ffffff;">
    <div class="container-fluid" #main [style.padding-top.px]="paddingtop">
        <div class="col-sm-12 px-0 align-self-end">
          <div class="row align-items-center">
            <div class="col-sm-10">
              <h5 class="light-header bold">
                {{ 'TBBO2_THERAPY_REPORT.LBL_TITLE' | translate}}
              </h5>
            </div>
            <!-- Exit button -->
            <!-- <div class="col-sm-2">
              <button type="button" class="btn btn-primary btn-sm float-right" (click)="exitBtnClickEvent()">
                <i class="fas fa-sign-out"></i> Exit
              </button>
            </div> -->
          </div>
          <hr class="mt-0 mb-3" />
        </div>
        <div class="pt-3">
          <div class="container border rounded p-3 bold">
            <form [formGroup]="iSForm">
              <div class="row">
                <div class="col-sm-6">
                  <div class="form-group row">
                    <label for="clinic" class="col-sm-3 col-form-label">Clinic Name</label>
                    <div class="col-sm-9">
                      <input type="text" class="form-control bold" id="clinicname" [hidden]="isSuperUser" autocomplete="off"
                      [(ngModel)]="clinicname" formControlName="clinicname" disabled/>
                      <ngx-select-dropdown tabindex="0" class="bold" formControlName="clinicfilter" (change)="clinicFilter()"
                            [multiple]="false"  [(ngModel)]="selectedClinicFilter" [hidden]="!isSuperUser"
                            [config]="{displayKey: 'ClinicName',search: true,height:'200px',placeholder:'Select Clinic',searchOnKey: 'ClinicName' }"
                            [options]="clinicsforfilter">
                      </ngx-select-dropdown>
                    </div>
                  </div>
                  <div class="form-group row">
                    <label for="equipment" class="col-sm-3 col-form-label">Equipment</label>
                    <div class="col-sm-9">
                      <select name="equipment" class="form-control bold" style="font-size: 14px;" [(ngModel)]="equipment" formControlName="equipment"
                      (change)="searchBtnClickEvent()">
                        <option *ngFor="let equipment of equipmentsforfilter" [ngValue]="equipment">{{equipment.EquipmentName}}</option>
                      </select>
                    </div>
                  </div>
                  <div class="form-group row">
                    <label for="user" class="col-sm-3 col-form-label">User</label>
                    <div class="col-sm-9">
                      <ngx-select-dropdown tabindex="0" class="bold" formControlName="userfilter" (change)="userFilter()"
                            [multiple]="false"  [(ngModel)]="selectedUserFilter"
                            [config]="{displayKey: 'UserName',search: true,height:'200px',placeholder:'Select User',searchOnKey: 'UserName' }"
                            [options]="usersforfilter">
                      </ngx-select-dropdown>
                    </div>
                  </div>

                  <div class="form-group row">
                      <label for="Date" class="col-sm-3 col-form-label">Date From</label>
                      <div class="col-sm-4">
                        <input type="text" class="form-control bold" bsDatepicker [ngModel] = "fromdate"
                        (bsValueChange)="onStartDateChange($event)" formControlName="fromdate"
                        value="{{ fromdate | date:'MM/dd/yyyy' }}"
                        [bsConfig]="{ containerClass: 'theme-default' }"
                        id="fromdate">
                      </div>
                      <label for="To" class="col-sm-1 col-form-label" style="text-align: center;">To</label>
                      <div class="col-sm-4">
                        <input type="text" class="form-control bold" bsDatepicker [ngModel] = "todate"
                        (bsValueChange)="onEndDateChange($event)" formControlName="todate"
                        value="{{ todate | date:'MM/dd/yyyy' }}"
                        [bsConfig]="{ containerClass: 'theme-default' }"
                        id="todate">
                      </div>
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="form-group row">
                    <label for="location" class="col-sm-3 col-form-label">Location</label>
                    <div class="col-sm-9">
                      <ngx-select-dropdown tabindex="0" class="bold" formControlName="locationfilter" (change)="locationFilter()"
                            [multiple]="false"  [(ngModel)]="selectedLocationFilter"
                            [config]="{displayKey: 'LocationName',search: true,height:'200px',placeholder:'Select Location',searchOnKey: 'LocationName' }"
                            [options]="locationsforfilter">
                      </ngx-select-dropdown>
                    </div>
                  </div>
                  <div class="form-group row">
                      <label for="therapymode" class="col-sm-3 col-form-label">Therapy Mode</label>
                      <div class="col-sm-9">
                        <select name="therapymode" class="form-control bold" style="font-size: 14px;" [(ngModel)]="therapymode" formControlName="therapymode"
                        (change)="searchBtnClickEvent()">
                          <option *ngFor="let therapymode of therapymodesforfilter" [ngValue]="therapymode">{{therapymode.TherapyModeName}}</option>
                        </select>
                      </div>
                  </div>
                  <div class="form-group row"  >
                    <label for="patientname" class="col-sm-3 col-form-label">Patient</label>
                    <div class="col-sm-9">
                      <input type="text" class="form-control bold" id="patientname" autocomplete="off"
                        formControlName="patientname" [(ngModel)]="patientname" (keyup)="searchBtnClickEvent()"/>
                    </div>
                  </div>
                  <div class="form-group row">
                    <div class="col-sm-3">
                      <div class="form-row">
                        <!-- <div class="form-group col-md-0">
                          <button type="button" class="btn btn-primary btn-sm" (click)="searchBtnClickEvent()"> <i class="far fa-save"></i> Search</button>
                        </div> -->
                        <div class="form-group col-md-0">
                          <button type="button" class="btn btn-primary btn-sm" (click)="cancelBtnClickEvent()"> <i class="far fa-times"></i> Cancel</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
		  </div>
		<div class="pt-3">
			<div class="container border rounded p-3 bold">
				<div id="grid-wrapper" class="col-sm-12 px-0" style="width: 100%; overflow: hidden;">
					<div class="col-sm-12 px-0" >
					  <ag-grid-angular style="width: 100%; height: 500px; " class="ag-theme-balham bold"
						[columnDefs]="columnDefs" (gridReady)="onGridReady($event)" [rowData]="rowData"
						(gridSizeChanged)="gridSizeChanged($event)" [defaultColDef]="defaultColDef"
            [animateRows]="true" [isExternalFilterPresent]="isExternalFilterPresent"
            [doesExternalFilterPass]="doesExternalFilterPass"
						[headerHeight]="60" [gridOptions]="gridOptions" >
					  </ag-grid-angular>
					</div>
				</div>
			</div>
		  </div>
      </div>
    </div>
